module.exports = __webpack_public_path__ + "static/media/LG 18_18sec.62c7aa42.mp3";